import React from "react";
import InternalSanityImage from "./InternalSanityImage";
import styles from "./SanityImage.module.scss";
import clsx from "clsx";
import { getLocalizedAlt, isSanityImagePresent } from "./utils";
import { PartialSanityImageType } from "./types";

export interface SanityImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  image: PartialSanityImageType | undefined;
  className?: string;
  fit?: "crop" | "original";
  jsLazy?: boolean;
  forceRenderPreview?: boolean;
}

const UncontrolledSanityImage: React.ForwardRefRenderFunction<
  HTMLDivElement,
  SanityImageProps
> = (
  {
    image = {},
    className,
    forceRenderPreview = false,
    fit = "crop",
    style,
    alt,
    ...imgTagProps
  },
  ref
) => {
  const ratioClass = clsx({
    [styles.imageFitCrop]: fit == "crop",
    [styles.imageFitOriginal]: fit == "original"
  });

  if (!isSanityImagePresent(image)) return null;
  const localizedAlt = getLocalizedAlt(alt);

  return (
    <div
      ref={ref}
      className={clsx([styles.container, ratioClass, className])}
      style={style}
    >
      <InternalSanityImage
        {...image}
        {...imgTagProps}
        forceRenderPreview={forceRenderPreview}
        alt={localizedAlt}
        fit={fit}
      />
    </div>
  );
};

export const SanityImage = React.memo(
  React.forwardRef(UncontrolledSanityImage)
);
